import { GoabButton } from "@abgov/react-components";

import { useGenerationFormReset } from "../../hooks";

export const RandomizeAndResetButton = () => {
  const { handleReset } = useGenerationFormReset();

  return (
    <>
      {/* Randomize and reset button */}
      <GoabButton mb="m" onClick={handleReset} type="secondary">
        Randomize and Reset
      </GoabButton>
    </>
  );
};
